import React from "react";
import { connect } from "react-redux";
import { callService, existeFecha, goTo } from "../tools";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { database } from "../app-database";
import { getCodigoFiliacion } from "../home/polizas.act";
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import TextField from 'material-ui/TextField';
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import StepperPaso1 from '../stepper-gnp-registro/stepper-paso1.cmpt';
import StepperResposnsivo1 from '../stepper-gnp-registro/stepper-responsivo1.cmpt';
import AvisoPrivacidad from "./avisoPrivacidad.cmpt";
import MensajeAyuda from "../modal-ayuda-registro/modal-ayuda-registro.cmpt";

const selector = formValueSelector("datos-poliza");
let isContrat = true;
let polizaGrupo = false;
let polizaAutos = false;
let certificadoCeros = "";
const msgValidacion = "La información coincide correctamente";
const validacion = "VALIDACIÓN";
let banderaIdenPoliza = false;
let certificadoPoliza = false;
let polizaBNMX = false;
const mensajeCampo = "Este campo sólo acepta números y letras.";
const mensajeErrorPlaca = "El número de placas no fue encontrado, verifica la información o ingresa el número de serie.";
const mensajeErrorSerie = "El número de serie no fue encontrado, verifica la información o ingresa el número de placa.";
const msjPolizaVencida = "Verifica la fecha de inicio de vigencia de tu póliza. Para asistencia haz clic en ayuda.";
let rfcValida = "";
const eventoRegistro = "EVENT_REGISTRO_SIG-CORRECTOS_POLIZA";
let contador = 0;
const modal1 = "#modal-ayuda-registro";

const mapState = (state) => {
    let dia = "", mes = "", anio = "";
    if (state.registro.inicioVigenciaPolizaDate != "") {
        let date = new Date(state.registro.inicioVigenciaPolizaDate);
        dia = (date.getDate() < 10) ? "0" + date.getDate() : date.getDate();
        mes = (date.getMonth() + 1 < 10) ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        anio = date.getFullYear();
    }
    let diaNacimiento = "", mesNacimiento = "", anioNacimiento = "";
    if (state.registro.fechaDeNacimientoDate != "") {

        let date = new Date(state.registro.fechaDeNacimientoDate);
        diaNacimiento = (date.getDate() < 10) ? "0" + date.getDate() : date.getDate();
        mesNacimiento = (date.getMonth() + 1 < 10) ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        anioNacimiento = date.getFullYear();
    }
    return {
        dataForm: selector(
            state, "poliza", "rfcValidar", "motor", "placas", "inicioVigenciaPolizaDate", "certificado", "dia", "mes", "anio",
            "polizaBanamex", "rfcbnmx", "fechaDeNacimientoDate", "diaNacimiento", "mesNacimiento", "anioNacimiento"
        ),
        paso: state.registro.paso,
        initialValues: {
            ramo: state.registro.ramo,
            poliza: state.registro.poliza,
            rfcValidar: state.registro.rfcValidar,
            inicioVigenciaPoliza: state.registro.inicioVigenciaPoliza,
            inicioVigenciaPolizaDate: state.registro.inicioVigenciaPolizaDate,
            certificado: state.registro.certificado,
            motor: state.registro.motor,
            placas: state.registro.placas,
            dia: dia,
            mes: mes,
            anio: anio,
            rfcbnmx: state.registro.rfcbnmx,
            diaNacimiento: diaNacimiento,
            mesNacimiento: mesNacimiento,
            anioNacimiento: anioNacimiento,
            fechaDeNacimiento: state.registro.fechaDeNacimiento,
            fechaDeNacimientoDate: state.registro.fechaDeNacimientoDate,
            polizaBanamex: state.registro.polizaBanamex,
            codFiliacion: state.registro.codFiliacion,
            idParticipante: state.registro.idParticipante,
            apaterno: state.registro.apaterno,
            amaterno: state.registro.amaterno,
            nombres: state.registro.nombres,
            avisoAceptado: state.registro.avisoAceptado,
            mediosElectronicos: state.registro.mediosElectronicos
        },
        grupo: state.registro.configuracion.grupo,
        motor: state.registro.configuracion.motor,
        certificado: state.registro.configuracion.certificado,
        poliza_valida: state.registro.configuracion.poliza_valida,
        poliza_padre: state.registro.configuracion.poliza_padre,
        referencia: state.registro.configuracion.referencia,
        conectaMovil: state.global.conectaMovil,
        dispositivo: state.global.dispositivo,
        showAviso: state.registro.showAviso,
    };
};

const mapDispatch = (dispatch) => {
    return {
        loader: (show) => {
            dispatch({ "type": "LOADER", "show": show });
        },
        polizaValidaFchVigInicial: (valida, fecha) => {
            dispatch({ "type": "REGISTRO_POLIZA_CONFIGURACION_VALIDA_FECHA", "poliza_valida": valida, "fchVigInicial": fecha });
        },
        aviso: (sMensaje) => {
            dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "Aviso de privacidad.", "mensaje": sMensaje });
        },
        avisoPrivacidad: (showAviso) => {
            dispatch({ "type": "AVISO_PRIVACIDAD", "showAviso": showAviso });
        },
        avisoTerminos: (showAviso) => {
            dispatch({ "type": "AVISO_TERMINOS", "showAviso": showAviso });
        },
        tagManager: (oDataTagManager) => {
            dispatch(oDataTagManager);
        },
        setPaso: (paso) => {
            dispatch({ "type": "REGISTRO_PASO", "paso": paso });
        },
        loading: (show) => {
            dispatch({ "type": "LOADING", "show": show });
        },
        alerta: (sMensaje) => {
            dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje": sMensaje });
        },
        alertaCode: (sCode) => {
            dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo": sCode });
        },
        guardarConfiguracion: (oConfiguracion) => {
            dispatch({ "type": "REGISTRO_POLIZA_CONFIGURACION", "configuracion": oConfiguracion });
        },
        polizaValida: (valida) => {
            dispatch({ "type": "REGISTRO_POLIZA_CONFIGURACION_VALIDA", "poliza_valida": valida });
        }
    };
};

const onSubmitFail = (errors, dispatch, props) => {
    if (errors.poliza != "Ingresa el No. de Póliza o Referencia" || errors.dia != "Campo requerido.") {
        dispatch({ "type": "EVENT_REGISTRO_SIG-INCORRECTOS_POLIZA", "dispositivo": "" });
    } else {
        dispatch({ "type": "EVENT_REGISTRO_SIG-VACIOS", "dispositivo": "" });
    }
};

const validate = values => {
    const errors = {};

    if (values.poliza === "" || values.poliza === undefined || values.poliza === null) {
        errors.poliza = "Ingresa el No. de Póliza o Referencia";
    }

    if (values.fechaPoliza === "" || values.fechaPoliza === undefined || values.fechaPoliza === null) {
        errors.fechaPoliza = "Ingresa la fecha de incio";
    }

    if (values.certificado === "" || values.certificado === undefined || values.certificado === null) {
        errors.certificado = "Ingresa el No. de certificado";
    }

    if (values.rfcbnmx === "" || values.rfcbnmx === undefined || values.rfcbnmx === null) {
        errors.rfcbnmx = "Campo requerido";
    } else {
        if (!/^[a-zA-Z0-9_]*$/i.test(values.rfcbnmx)) {
            errors.rfcbnmx = mensajeCampo;
        }
        if (/^[a-zA-Z]{3,4}(\d{6})((\D|\d){2,3})?$/.test(values.rfcbnmx) === false) {
            errors.rfcbnmx = "Formato de RFC inválido.";
        } else if (values.rfcbnmx && values.fechaNacimiento) {
            const dia = values.fechaNacimiento.substr(8, 9);
            const mes = values.fechaNacimiento.substr(5, 2);
            const anio = values.fechaNacimiento.substr(0, 4);
            const fechaComparativa = anio.substr(2, 4) + mes + dia;

            if (values.rfcbnmx.substr("4", "6") !== fechaComparativa) {
                errors.rfcbnmx = "El RFC no concuerda con la fecha de nacimiento.";
            } else {
                errors.rfcbnmx = "";
            }
        }
    }

    if (values.fechaNacimiento === "" || values.fechaNacimiento === undefined || values.fechaNacimiento === null) {
        errors.fechaNacimiento = "Campo requerido";
    }

    if (!/^[a-zA-Z0-9_-]*$/i.test(values.poliza)) {
        errors.poliza = mensajeCampo;
    }

    if (values.certificado && values.certificado.length < 8 && polizaGrupo === false) {
        errors.certificado = "Este campo no puede ser menor de 8 caracteres.";
    } else if (values.certificado && !/^[a-zA-Z0-9_-]*$/i.test(values.certificado)) {
        errors.certificado = mensajeCampo;
    }

    if (existeFecha(values.dia, values.mes, values.anio) === false) {
        errors.dia = "La fecha inicio de vigencia es inválida. Verifícala e intenta de nuevo.";
    }

    return errors;
};

const espacios = value => {
    let texto = (value != undefined) ? value.replace(/\s/g, "") : "";
    return texto.toUpperCase();
};

const limpiar = (value) => {
    return (value != undefined) ? value.replace(/\s/g, "").toUpperCase() : "";
};

const campoSettings = {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 'normal',
    mixBlendMode: 'normal',
}

const floatingLabelStyleSettings = {
    ...campoSettings,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: '#567099'
}

const floatingLabelFocusStyleSettings = {
    ...campoSettings,
    lineHeight: '16px',
    letterSpacing: '0.5px',
    color: '#FF6B0B',
}

const campo = ({ input, label, max, type, focus, meta: { touched, error } }) => {
    return (
        <MuiThemeProvider>
            <TextField
                {...input}
                floatingLabelText={label}
                fullWidth={true}
                underlineStyle={{ borderColor: '#AAC3EE' }}
                underlineFocusStyle={{ borderColor: '#FF6B0B' }}
                floatingLabelStyle={floatingLabelStyleSettings}
                floatingLabelFocusStyle={floatingLabelFocusStyleSettings}
                type={type}
                onFocus={focus}
                onBlur={(event) => { input.onBlur(event); }}
                onChange={(event) => { input.onChange(event); }}
                maxLength={max}
                errorText={touched && error}
                onKeyPress={(event) => {
                    if (event.key === 'Enter') {
                        handleKeyPress(input);
                    }
                }}
            />
        </MuiThemeProvider>
    );
};

const handleKeyPress = (input) => {
    const inputActual = input.name;
    const inputs = document.getElementsByTagName('input');

    for (let index = 0; index < inputs.length; index++) {
        if (inputActual === inputs[index].name) {

            switch (input.name) {
                case "rfc":
                    console.log("RFC");
                    document.getElementById(inputs[index].id).blur();
                    setTimeout(() => {
                        document.getElementById(inputs[index + 1].id).focus();
                    }, 10);
                    break;
                case "poliza":
                    document.getElementById(inputs[index].id).blur();
                    setTimeout(() => {
                        document.getElementById(inputs[index + 1].id).focus();
                    }, 10);
                    break;
                case "fechaPoliza":
                    document.getElementById(inputs[index].id).blur();
                    document.getElementById("btnAceptarAviso").focus();
                    break;
                case "certificado":
                    document.getElementById(inputs[index].id).blur();
                    setTimeout(() => {
                        document.getElementById("btnAceptarAviso").focus();
                    }, 500);
                    break;
                case "rfcbnmx":
                    document.getElementById(inputs[index + 1].id).focus();
                    break;
                case "fechaNacimiento":
                    for (const i of inputs) {
                        if ("placas" === i.name) {
                            document.getElementById(i.id).focus();
                        }
                    }
                    break;
                case "tipo":
                    console.log("tipo");
                    break;
                case "placas":
                    console.log("placas");
                    document.getElementById(inputs[index + 1].id).focus();
                    break;
                case "motor":
                    console.log("motor");
                    document.getElementById(inputs[index].id).blur();
                    document.getElementById("btnAceptarAviso").focus();
                    break;
                default:
                    break;
            }
        }
    }
}

function MyError(message) {
    this.message = { "codigoError": "ERROR", "mensaje": "Lo sentimos, verifica el RFC y fecha de nacimiento" };
}

MyError.prototype = Object.create(Error.prototype);
MyError.prototype.constructor = MyError;

class PolizaForm extends React.Component {

    state = {
        autos: "", vida: "", gm: "", danios: "",
        images: [
            require("../img/icon_autos_off.svg"),
            require("../img/icon_vida_off.svg"),
            require("../img/icon_gastos_off.svg"),
            require("../img/icon_danos_off.svg"),
            require("../img/icon_autos.svg"),
            require("../img/icon_vida.svg"),
            require("../img/icon_gastos.svg"),
            require("../img/icon_danos.svg")
        ],
        ramo: "",
        poliza: "",
        rfcValida: "",
        polizaReal: "",
        disabledMotor: false,
        disabledPlacas: false,
        rfcbnmx: "",
        polizaBanamex: false,
        codFiliacion: "",
        idParticipante: "",
        apaterno: "",
        amaterno: "",
        nombres: "",
        fechaDeNacimiento: "",
        fechaDeNacimientoDate: "",
        mensajeAviso: "",
        tipo: "contratante",
        esContratante: true,
        mensajeTratamientoDatos: "",
        messageExito: false,
        messageExitoAuto: false,
        messageError: false,
        loadingPequeno: false,
        loadingPequeno2: false,
        btnHabilitado: true,
        showTooltip: false,
        mensaje: "",
        type: "",
        titulo: "",
        inputType: "",
        inputType2: "",
        loadingPequenoMotor: false,
        sistema: "",
        fechaIncompleta: false,
        grupoPolizaPadre: false,
        polizaPadre: false,
        ramoPolizaPadre: "",
        showInput: true,
        name: "",
        label: "",
        tipoAuto: "",
        placas: false,
        serie: false,
        showModalAyuda: false,
        tipoModalAyuda: "",
        avisosAceptados: false,
        errorAvisosAceptados: false
    }

    handleChangeRadio() {
        this.setState({
            checked: !this.state.checked
        })
        $(modal1).modal("hide");
    }

    componentWillMount = () => {
        $(modal1).modal("hide");
        localStorage.removeItem("mensajeAyuda");
        this.setRamo(this.props.initialValues.ramo);
        const $this = this;

        database.ref("/documentacion/avisoSimplificado").once("value").then(function (data) {
            $this.setState({ "mensajeAviso": data.val() });
        });

        database.ref("/documentacion/avisoTratamientoDatos").once("value").then(function (data) {
            $this.setState({ "mensajeTratamientoDatos": data.val() });
        });

        if (this.props.initialValues.inicioVigenciaPoliza !== "") {
            if (localStorage.getItem("polizaBanamex") !== null) {
                this.props.change("poliza", localStorage.getItem("polizaBanamex"));
                this.checkPolizaBanamex(localStorage.getItem("polizaBanamex"));
                this.props.change("fechaNacimiento", this.props.initialValues.fechaDeNacimiento);
                if (this.state.tipo === 'contratante') {
                    this.props.change("esContratante", true);
                    this.props.change("tipo", this.state.tipo);
                } else {
                    this.props.change("esContratante", false);
                    this.props.change("tipo", this.state.tipo);
                }
            } else {
                localStorage.removeItem('polizaBanamex');
            }

            this.props.change("avisoAceptado", true);
            this.setState({ "avisoAceptado": true });
            setTimeout(() => {
                this.setState({ inputType: 'date' });
                this.setState({ inputType2: 'date' });
                this.setState({ "mediosElectronicos": true });
                this.props.change("mediosElectronicos", true);
                this.props.change("fechaPoliza", this.props.initialValues.inicioVigenciaPoliza);
                this.setState({ btnHabilitado: false });
                this.setState({ sistema: localStorage.getItem('sistema') });
            }, 50);
        } else {
            localStorage.removeItem('cveClienteUnico');
            localStorage.removeItem('urlSeguridad');
            localStorage.removeItem('hashOne');
            localStorage.removeItem('hashTwo');
            localStorage.removeItem('email');
            localStorage.removeItem('telefono');
            localStorage.removeItem('fechaNacimiento');
            localStorage.removeItem('validoOTP');
            localStorage.removeItem('actualizo');
            localStorage.removeItem('polizaBanamex');
            localStorage.removeItem('sistema');
            localStorage.removeItem('poliza');
            localStorage.removeItem('certificado');
            localStorage.removeItem("ramo");
            localStorage.removeItem("fechaNacimientoBMX");
            localStorage.removeItem("polizaReal");
        }
    }

    resetRamo = () => {
        this.setState({
            autos: this.state.images[0],
            vida: this.state.images[1],
            gm: this.state.images[2],
            danios: this.state.images[3]
        });
    }

    resetConfiguracion = () => {
        $(modal1).modal("hide");
        this.props.guardarConfiguracion({
            grupo: false, motor: false, certificado: false, poliza_valida: false, poliza_padre: false,
            fchVigInicial: false, referencia: false, sistema: false
        });
        this.props.change("certificado", "");
        this.props.change("placas", "");
        this.props.change("motor", "");
        this.props.untouch("placas");
        this.props.untouch("motor");
        this.props.untouch("certificado");
        this.props.change("checkPolizaBanamex", false);
        this.props.change("fechaDeNacimiento", "");
        this.props.untouch("checkPolizaBanamex");
        this.props.untouch("fechaDeNacimiento");
        this.setState({ polizaBanamex: false });
    }

    setPolizaReal = (sPoliza) => {
        this.setState({ polizaReal: sPoliza });
        this.props.change("polizaReal", sPoliza);
    }

    setRamo = (sRamo) => {
        this.resetRamo();
        this.setState({ ramo: sRamo });
        this.props.change("ramo", sRamo);
        switch (sRamo) {
            case "A": this.setState({ "autos": this.state.images[4] });
                break;
            case "V": this.setState({ "vida": this.state.images[5] });
                break;
            case "G": this.setState({ "gm": this.state.images[6] });
                break;
            case "D": this.setState({ "danios": this.state.images[7] });
                break;
        }
    }

    setDetallesPoliza(clienteUnico, idParticipante, apaterno, amaterno, nombres) {
        this.setState({ codFiliacion: clienteUnico });
        this.props.change("codFiliacion", clienteUnico);

        this.setState({ idParticipante: idParticipante });
        this.props.change("idParticipante", idParticipante);

        this.setState({ apaterno: apaterno });
        this.props.change("apaterno", apaterno);

        this.setState({ amaterno: amaterno });
        this.props.change("amaterno", amaterno);

        this.setState({ nombres: nombres });
        this.props.change("nombres", nombres);
    }

    setRFC = (sRFC) => {
        this.setState({ rfcbnmx: sRFC });
        this.props.change("rfcbnmx", sRFC);
        console.log("Entra RFC:", this.setRFC);
    }

    checkPolizaBanamex = (spolizaBanamex) => {
        if (spolizaBanamex.startsWith('CBX') || spolizaBanamex.startsWith('cbx')) {
            this.setState({ polizaBanamex: true });
            this.props.change("polizaBanamex", true);
        } else {
            this.setState({ polizaBanamex: false });
            this.props.change("polizaBanamex", false);
        }
    }

    getFechaVigencia = () => {
        let fechaPoliza = document.getElementsByName("fechaPoliza")[0].value;
        if (rfcValida !== '' && localStorage.getItem('inicioVigenciaPolizaNuevaFV')) {
            fechaPoliza = localStorage.getItem('inicioVigenciaPolizaNuevaFV');
        }
        var dia = fechaPoliza.substr(8, 9);
        var mes = fechaPoliza.substr(5, 2);
        var anio = fechaPoliza.substr(0, 4);

        if (fechaPoliza !== "") {
            const date = new Date(fechaPoliza);
            this.props.change("inicioVigenciaPoliza", fechaPoliza);
            this.props.change("inicioVigenciaPolizaDate", date.getTime());

            return dia + "/" + mes + "/" + anio;
        } else {
            return '';
        }
    }

    getTipo = () => {
        return document.getElementsByName("tipo")[0].value;
    }

    getFechaNacimiento = () => {
        const fechaNacimiento = document.getElementsByName("fechaNacimiento")[0].value;
        const dia = fechaNacimiento.substr(8, 9);
        const mes = fechaNacimiento.substr(5, 2);
        const anio = fechaNacimiento.substr(0, 4);

        if (fechaNacimiento !== "") {
            const date = new Date(fechaNacimiento);
            this.props.change("fechaDeNacimiento", fechaNacimiento);
            this.props.change("fechaDeNacimientoDate", date.getTime());

            return dia + "/" + mes + "/" + anio;
        } else {
            return '';
        }
    }

    getFechatoActualiza = () => {
        const fechaNacimiento = document.getElementsByName("fechaNacimiento")[0].value;
        const dia = fechaNacimiento.substr(8, 9);
        const mes = fechaNacimiento.substr(5, 2);
        const anio = fechaNacimiento.substr(0, 4);

        if (dia !== "" && mes !== "" && anio !== "") {
            return anio + mes + dia;
        } else {
            return "00000000";
        }
    }

    getFechaToDate = (sFecha) => {
        sFecha = sFecha.split("/").reverse();
        sFecha = new Date(sFecha[0], sFecha[1] - 1, sFecha[2]);
        return sFecha.getTime();
    }

    fechaformat = (sFecha) => {
        sFecha = sFecha.split("/").reverse();
        return sFecha[0] + sFecha[1] + sFecha[2];
    }

    handleFocusPoliza = (event) => {
        const tipo = event.target.name;
        const oForm = this.props.dataForm;
        const fechaPoliza = document.getElementsByName("fechaPoliza")[0].value;
        if (tipo === "poliza" || tipo === "fechaPoliza" || tipo === "rfc") {
            this.resetConfiguracion();
            if (fechaPoliza !== "") {
                if (oForm.poliza !== "" && this.getFechaVigencia() !== "" && oForm.rfc) {
                    if (fechaPoliza !== undefined && fechaPoliza !== "") {
                        this.validarPoliza(oForm);
                    }
                }
            }
        }
    }

    validarPolizaClick = () => {
        const oForm = this.props.dataForm;
        const fechaPoliza = document.getElementsByName("fechaPoliza")[0].value;
        const poliza = document.getElementsByName("poliza")[0].value;

        this.resetConfiguracion();
        if (fechaPoliza !== "" && poliza !== "") {
            if (oForm.poliza !== "" && this.getFechaVigencia()) {
                if (fechaPoliza !== undefined && fechaPoliza !== "") {
                    this.validarPoliza(oForm);
                }
            }
        } else {
            this.props.handleSubmit(values => this.props.onSubmit({ ...values }))();
        }
    }

    handleBlur = (event) => {
        $(modal1).modal("hide");
        this.onBlurFecha();
        const tipo = event.target.name;
        const oForm = this.props.dataForm;
        if (tipo === "poliza" && oForm.dia !== "" && oForm.mes !== "" && oForm.anio !== "" && event.target.value !== "") {
            this.resetConfiguracion();
        }
    }

    closeMessageValidacion = () => {
        this.setState({ messageExito: false });
        this.setState({ messageError: false });
        this.validarCheck();
    }

    handleFocus = (event) => {
        const tipo = event.target.name;
        if (tipo === "placas" || tipo === "motor") {
            this.props.polizaValida(false);
        }
    }

    validarPoliza = (oForm) => {
        const poliza = document.getElementsByName('poliza')[0].value;
        const fechaPoliza = document.getElementsByName('fechaPoliza')[0].value;
        localStorage.setItem('polizaReal', poliza);

        localStorage.removeItem("registroAsistido");
        this.setState({ sistema: "" });
        localStorage.removeItem('sistema');
        const $this = this;
        this.setState({ loadingPequeno: true });

        if (oForm.poliza.toUpperCase().substr(0, 3) === "CBX") {
            localStorage.setItem("polizaBanamex", oForm.poliza);
        } else {
            // comentario
        }

        if (banderaIdenPoliza === false || poliza !== localStorage.getItem('polizaNueva') ||
            fechaPoliza !== localStorage.getItem('inicioVigenciaPolizaNueva') || rfc !== localStorage.getItem('inicioVigenciaPolizaNueva')) {
            new callService({
                service: "utilerias.identificaPoliza",
                secure: true,
                data: { poliza: limpiar(oForm.poliza), fecha: $this.getFechaVigencia() }
            }).execute().then((oResult) => {
                rfcValida = oResult.rfc;
                localStorage.removeItem('inicioVigenciaPolizaNuevaFV');
                this.validarPolizaState(oResult, oForm);
            }).catch((error) => {
                this.respuestaErrorValidarPoliza(error, oForm);
            });
        } else {
            this.pasoSiguiente();
        }
    }

    validarPolizaState = (oResult, oForm) => {
        const $this = this;
        if (oResult.rfc === '') {
            $this.setPolizaReal(oResult.numPoliza);
            this.setState({ polizaBanamex: false });
            this.props.change("polizaBanamex", false);
            const banamex = localStorage.getItem("polizaBanamex");

            if (oResult.grupo === true && oResult.sistema === "INFO" && oResult.ramo === "G") {
                polizaGrupo = true;
            } else {
                polizaGrupo = false;
            }

            if (oResult.grupo === true && oResult.poliza_padre === true && oResult.ramo === "G") {
                this.setState({ grupoPolizaPadre: oResult.grupo });
                this.setState({ polizaPadre: oResult.poliza_padre });
                this.setState({ ramoPolizaPadre: oResult.ramo });
            }

            if (oResult.ramo === "A" && oResult.grupo === true &&
                (banamex === null || banamex === undefined)) {
                polizaAutos = true;
                this.detallePoliza(oForm);
            } else {
                polizaAutos = false;
                this.checkPolizaBanamex(oForm.poliza);
            }

            $this.props.tagManager({
                "type": eventoRegistro, "dispositivo": $this.props.dispositivo, "ramo": localStorage.getItem("ramo")
            });

            certificadoPoliza = oResult.certificado;
            $this.setRamo(oResult.ramo);
            console.log(oResult.numPoliza);
            $this.props.guardarConfiguracion(oResult);
            this.setState({ sistema: oResult.sistema });
            this.ramos(oResult);
            this.vaildarRegistroInconcluso(oForm, oResult);
            this.setState({ messageError: false });
            this.setState({ messageExito: true });
            this.muestraTooltip(true, 'exito', validacion, msgValidacion);
            banderaIdenPoliza = true;
        } else {
            this.setState({ rfcValida: oResult.rfc, rfcisEmpty: true });
            this.setState({ loadingPequeno: false });
            if (rfcValida === oForm.rfcValidar) {
                this.respuestaAgregaFechaVig(oResult.fchVigenciaInicial);
                $this.setPolizaReal(oResult.numPoliza);
                this.setState({ polizaBanamex: false });
                this.props.change("polizaBanamex", false);
                const banamex = localStorage.getItem("polizaBanamex");

                if (oResult.grupo === true && oResult.sistema === "INFO" && oResult.ramo === "G") {
                    polizaGrupo = true;
                } else {
                    polizaGrupo = false;
                }

                if (oResult.grupo === true && oResult.poliza_padre === true && oResult.ramo === "G") {
                    this.setState({ grupoPolizaPadre: oResult.grupo });
                    this.setState({ polizaPadre: oResult.poliza_padre });
                    this.setState({ ramoPolizaPadre: oResult.ramo });
                }

                if (oResult.ramo === "A" && oResult.grupo === true &&
                    (banamex === null || banamex === undefined)) {
                    polizaAutos = true;
                    this.detallePoliza(oForm);
                } else {
                    polizaAutos = false;
                    this.checkPolizaBanamex(oForm.poliza);
                }
                $this.props.tagManager({
                    "type": eventoRegistro, "dispositivo": $this.props.dispositivo, "ramo": localStorage.getItem("ramo")
                });

                certificadoPoliza = oResult.certificado;
                $this.setRamo(oResult.ramo);
                console.log(oResult.numPoliza);
                $this.props.guardarConfiguracion(oResult);
                this.setState({ sistema: oResult.sistema });
                this.ramos(oResult);
                this.vaildarRegistroInconcluso(oForm, oResult);
                this.setState({ messageError: false });
                this.setState({ messageExito: true });
                this.muestraTooltip(true, 'exito', validacion, msgValidacion);
                banderaIdenPoliza = true;
            } else if (oForm.rfcValidar !== undefined) {
                this.muestraTooltip(true, 'error', validacion, "El RFC no coincide con el de la póliza.");
            }
        }
    }

    respuestaAgregaFechaVig = (fch) => {
        if (fch !== '') {
            const date = new Date(fch);
            this.props.change("inicioVigenciaPoliza", fch);
            this.props.change("inicioVigenciaPolizaDate", date.getTime());
            localStorage.setItem('inicioVigenciaPolizaNuevaFV', fch);
        }
    }

    respuestaExitoValidarPoliza = (oResult, oForm) => {
        const $this = this;
        $this.setPolizaReal(oResult.numPoliza);
        this.setState({ polizaBanamex: false });
        this.props.change("polizaBanamex", false);
        const banamex = localStorage.getItem("polizaBanamex");

        if (oResult.grupo === true && oResult.sistema === "INFO" && oResult.ramo === "G") {
            polizaGrupo = true;
        } else {
            polizaGrupo = false;
        }

        if (oResult.grupo === true && oResult.poliza_padre === true && oResult.ramo === "G") {
            this.setState({ grupoPolizaPadre: oResult.grupo });
            this.setState({ polizaPadre: oResult.poliza_padre });
            this.setState({ ramoPolizaPadre: oResult.ramo });
        }

        if (oResult.ramo === "A" && oResult.grupo === true &&
            (banamex === null || banamex === undefined)) {
            polizaAutos = true;
            this.detallePoliza(oForm);
        } else {
            polizaAutos = false;
            this.checkPolizaBanamex(oForm.poliza);
        }

        $this.props.tagManager({
            "type": eventoRegistro, "dispositivo": $this.props.dispositivo, "ramo": localStorage.getItem("ramo")
        });

        certificadoPoliza = oResult.certificado;
        $this.setRamo(oResult.ramo);
        console.log(oResult.numPoliza);
        $this.props.guardarConfiguracion(oResult);
        this.setState({ sistema: oResult.sistema });
        this.ramos(oResult);
        this.vaildarRegistroInconcluso(oForm, oResult);
        this.setState({ messageError: false });
        this.setState({ messageExito: true });
        this.muestraTooltip(true, 'exito', validacion, msgValidacion);
        banderaIdenPoliza = true;
    }

    respuestaErrorValidarPoliza = (error) => {
        const $this = this;
        localStorage.removeItem('polizaNueva');
        localStorage.removeItem('inicioVigenciaPolizaNueva');
        localStorage.removeItem('sistema');
        $this.props.tagManager({
            "type": "EVENT_REGISTRO_SIG-INCORRECTOS_POLIZA", "dispositivo": $this.props.dispositivo, "ramo": localStorage.getItem("ramo")
        });

        $this.resetConfiguracion();
        this.setState({ loadingPequeno: false });
        this.setState({ messageExito: false });
        this.setState({ messageError: true });

        if (JSON.stringify(error) === "{}") {
            console.log("1");
            this.muestraTooltip(true, 'error', validacion, "Ocurrio un error, intente más tarde.");
        } else
            if (error.message) {
                if (error.message.mensaje.includes("Lo sentimos, favor de verificar")) {
                    console.log("2");
                    this.muestraTooltip(true, 'error', validacion, "Error, Favor de verificar el número de póliza o fecha de inicio de vigencia.");
                } else if (error.message.mensaje.includes(msjPolizaVencida)) {
                    console.log("3");
                    this.muestraTooltip(true, 'error', "PÓLIZA FUERA DE VIGENCIA", error.message.mensaje);
                } else if (error.message.mensaje === "" || error.message.codigoError === "500") {
                    console.log("4");
                    this.muestraTooltip(true, 'error', validacion, "Ocurrio un error, intente más tarde.");
                } else {
                    console.log("5");
                    this.muestraTooltip(true, 'error', validacion, error.message.mensaje);
                }
            } else {
                console.log("6");
                this.muestraTooltip(true, 'error', validacion, error.message.mensaje);
            }
    }

    ramos = (oResult) => {
        var ramo = "";
        if (oResult.ramo === "G") {
            ramo = "Gastos Medicos";
        } else if (oResult.ramo === "V") {
            ramo = "Vida";
        } else if (oResult.ramo === "A") {
            ramo = "Autos";
        } else {
            ramo = "Daños";
        }
        localStorage.setItem("ramo", ramo);
    }

    validaUsuario = (respuesta, oResult, polizaCeros) => {
        new callService({
            service: "registro.incConsultaDatosReg",
            secure: true,
            data: {
                uid: respuesta.path
            }
        }).execute().then((respuesta2) => {
            localStorage.setItem("correoModal", respuesta2.email);
            new callService({
                service: 'registro.obtenerNombreMedios',
                "secure": true,
                data: { email: respuesta2.email }
            }).execute().then(body => {
                console.log(body);
                localStorage.setItem("banConcluirRegPoliza", respuesta.banConcluirReg);
                localStorage.setItem("poliza", polizaCeros);
                localStorage.setItem("sistema", oResult.sistema);
                this.setState({ loadingPequeno: false });
                this.props.setPaso(1);
            }).catch(error => {
                console.log(error);
                this.setState({ loadingPequeno: false });
            });
        }).catch((error) => {
            console.log("Error", error);
        });
    }

    validarMotorPlacas = () => {
        const poliza = document.getElementsByName('poliza')[0].value;
        const fechaPoliza = document.getElementsByName('fechaPoliza')[0].value;
        const placas = document.getElementsByName('placas')[0] === undefined ? "" : document.getElementsByName('placas')[0].value;
        const motor = document.getElementsByName('motor')[0] === undefined ? "" : document.getElementsByName('motor')[0].value;

        console.log(poliza, fechaPoliza, this.state.polizaBanamex, placas, motor);

        if (poliza !== '' && fechaPoliza !== '' && !this.state.polizaBanamex && (placas !== '' || motor !== '')) {
            console.log('manda a validar');
            this.validarAuto(this.props.dataForm);
        }
    }

    validarAuto = (oForm) => {
        console.log('aqui avanza', oForm);
        const $this = this;
        oForm.poliza = this.state.polizaReal;
        $this.props.polizaValida(false);
        this.setState({ loadingPequenoMotor: true });

        new callService({
            service: "utilerias.identificaPolizaAuto",
            secure: true,
            data: {
                poliza: limpiar(oForm.poliza), motor: limpiar(oForm.motor), placas: limpiar(oForm.placas), fecha: $this.getFechaVigencia()
            }
        }).execute().then((oResult) => {
            this.setState({ loadingPequenoMotor: false });
            this.muestraTooltip(true, 'exito', validacion, msgValidacion);
            console.log("Respuesta", oResult);
            $this.props.tagManager({
                "type": "EVENT_REGISTRO_SIG-AUTOS-CORRECTOS", "dispositivo": $this.props.dispositivo, "ramo": localStorage.getItem("ramo")
            });
            $this.props.polizaValida(true);
            this.setState({ messageError: false });
            this.setState({ messageExitoAuto: true });
            this.pasoSiguiente();
        }).catch((error) => {
            console.log("Error", error);
            $this.props.tagManager({ "type": "EVENT_REGISTRO_SIG-AUTOS-INCORRECTOS", "dispositivo": $this.props.dispositivo });
            this.setState({ loadingPequenoMotor: false });
            let mensaje = mensajeErrorPlaca;
            if (oForm.motor) {
                mensaje = mensajeErrorSerie;
            }
            this.muestraTooltip(true, 'error', validacion, mensaje);
            this.setState({ loadingPequeno: false });
            this.setState({ messageExitoAuto: false });
        });
    }

    detallePoliza = (oForm) => {
        new callService({
            service: "utilerias.detallePoliza",
            secure: false,
            data: { poliza: this.state.polizaReal }
        }).execute().then((oResult) => {
            console.log("Detalle poliza", oResult);

            if (oResult.cveProdTecnico === "A2400FLOT" && oResult.cveProdComercial === "00009") {
                this.setState({ polizaBanamex: true });
                this.props.change("polizaBanamex", true);
                polizaBNMX = true;
                polizaAutos = false;
                this.handlePressSieguiente();
            } else {
                polizaBNMX = false;
                polizaAutos = true;
                this.setState({ polizaBanamex: false });
                this.props.change("polizaBanamex", false);
            }
            this.actualizaPersona(oResult, oForm);
        }).catch((error) => {
            console.log("Error", error);
            this.setState({ polizaBanamex: false });
            this.props.change("polizaBanamex", false);
        });
    }

    actualizaPersona = (params, oForm) => {
        let idParticipante = "";
        let apaterno = "";
        let amaterno = "";
        let nombres = "";
        let fechaNacimiento = "";
        const RFC = oForm.rfcbnmx;
        const usuarioAudit = "operadorcrm";
        if (!isContrat) {
            console.log("es conducto");
            if (params.conductor === null) {
                idParticipante = params.contratante.idParticipante;
                apaterno = params.contratante.apellidoPaterno;
                amaterno = params.contratante.apellidoMaterno;
                nombres = params.contratante.nombres;
                fechaNacimiento = this.getFechatoActualiza();
            } else {
                idParticipante = params.conductor.idParticipante;
                apaterno = params.conductor.apellidoPaterno;
                amaterno = params.conductor.apellidoMaterno;
                nombres = params.conductor.nombres;
                fechaNacimiento = this.getFechatoActualiza();
            }
        } else if (isContrat) {
            if (params.contratante === null) {
                idParticipante = params.conductor.idParticipante;
                apaterno = params.conductor.apellidoPaterno;
                amaterno = params.conductor.apellidoMaterno;
                nombres = params.conductor.nombres;
                fechaNacimiento = this.getFechatoActualiza();
            } else {
                idParticipante = params.contratante.idParticipante;
                apaterno = params.contratante.apellidoPaterno;
                amaterno = params.contratante.apellidoMaterno;
                nombres = params.contratante.nombres;
                fechaNacimiento = this.getFechatoActualiza();
            }
        }

        if (RFC !== '' && RFC !== undefined) {
            this.codFiliacion(idParticipante, apaterno, amaterno, nombres, fechaNacimiento, RFC, usuarioAudit);
        } else {
            console.log('primera llamada vacia');
        }
    }

    codFiliacion = (idParticipante, apaterno, amaterno, nombres, fechaNacimiento, RFC, usuarioAudit) => {

        getCodigoFiliacion(idParticipante).then((codFiliacion) => {
            if (codFiliacion && idParticipante && apaterno && nombres) {
                this.setDetallesPoliza(codFiliacion, idParticipante, apaterno, amaterno, nombres);
                const llamaServicio = new callService({
                    service: "utilerias.actualizaPersona",
                    secure: true,
                    data: {
                        codigoFiliacion: codFiliacion,
                        idParticipante: idParticipante,
                        RFC: RFC,
                        fechaNacimiento: fechaNacimiento,
                        apellidoPaterno: apaterno,
                        apellidoMaterno: amaterno,
                        nombre: nombres,
                        usuarioAudit: usuarioAudit
                    }
                });
                return llamaServicio.execute().then((oResult) => {
                    console.log("oResult", oResult);
                    if (oResult.actualizaPersona) {
                        console.log('listo');
                        this.validarAuto(this.props.dataForm);
                    } else {
                        this.setState({ loadingPequeno2: false });
                        console.log('error');
                    }
                });
            } else {
                this.setState({ loadingPequeno2: false });
                throw new MyError("ERROR");
            }
        }).catch((error) => {
            console.log("Error", error);

            this.setState({ loadingPequeno2: false });
            this.setState({ loadingPequeno: false });
            this.muestraTooltip(true, 'error', validacion, error.message.mensaje);
            throw new MyError("ERROR");
        });
    }

    actualizaPolizaBanamex = (oForm) => {
        console.log('actualiza banamex', oForm);
        this.setState({ loadingPequenoMotor: true });
        this.detallePoliza(oForm);
    }

    validarCertificado = (oForm) => {
        const $this = this;
        $this.props.polizaValida(false);
        this.setState({ loadingPequeno2: true });

        if (polizaGrupo === true) {
            certificadoCeros = document.getElementsByName("certificado")[0].value.padStart(10, 0);
        }
        else if (document.getElementsByName("certificado")[0].value !== undefined) {
            certificadoCeros = document.getElementsByName("certificado")[0].value;
        }

        if (this.state.grupoPolizaPadre === true && this.state.polizaPadre === true && this.state.ramoPolizaPadre === "G") {
            this.validarCertificadoPadre(oForm);
        } else {
            new callService({
                service: "utilerias.identificaCertificado",
                secure: true,
                data: { poliza: limpiar(oForm.poliza), certificado: limpiar(certificadoCeros), sistema: $this.props.certificado }
            }).execute().then((oResult) => {
                console.log("Respuesta", oResult);

                var type = ($this.state.ramo === "V") ? "EVENT_REGISTRO_SIG-VIDA-CORRECTOS" : "EVENT_REGISTRO_SIG-GMM-CORRECTOS";
                $this.props.tagManager({ "type": type, "dispositivo": $this.props.dispositivo });

                this.setState({ loadingPequeno2: false });
                this.setState({ messageError: false });
                this.setState({ messageExito: true });
                this.muestraTooltip(true, 'exito', validacion, msgValidacion);
                $this.props.polizaValida(true);
                setTimeout(() => {
                    console.log(this.state.polizaReal);
                    this.pasoSiguiente();
                }, 500);

            }).catch((error) => {
                console.log("Error", error);
                var type = ($this.state.ramo === "V") ? "EVENT_REGISTRO_SIG-VIDA-INCORRECTOS" : "EVENT_REGISTRO_SIG-GMM-INCORRECTOS";
                $this.props.tagManager({ "type": type, "dispositivo": $this.props.dispositivo });
                this.setState({ loadingPequeno2: false });
                this.setState({ messageError: true });
                this.muestraTooltip(true, 'error', validacion, error.message.mensaje);
                this.setState({ messageExito: false });
                this.validarCheck();
            });
        }
    }

    validarCertificadoPadre = (oForm) => {
        const $this = this;
        $this.props.polizaValida(false);
        new callService({
            service: "utilerias.identificaPolizaHija",
            secure: true,
            data: { poliza: limpiar(oForm.poliza), certificado: limpiar(oForm.certificado), sistema: $this.props.certificado }
        }).execute().then((oResult) => {
            console.log("Respuesta", oResult);
            var type = ($this.state.ramo === "V") ? "EVENT_REGISTRO_SIG-VIDA-CORRECTOS" : "EVENT_REGISTRO_SIG-GMM-CORRECTOS";
            $this.props.tagManager({ "type": type, "dispositivo": $this.props.dispositivo });
            $this.props.polizaValidaFchVigInicial(oResult.numPoliza, $this.getFechaToDate(oResult.fchVigInicial));
            this.setState({ loadingPequeno2: false });
            this.muestraTooltip(true, 'exito', validacion, msgValidacion);

            setTimeout(() => {
                console.log(this.state.polizaReal);
                this.pasoSiguiente();
            }, 500);
        }).catch((error) => {
            console.log("Error", error);

            setTimeout(() => {
                this.setState({ loadingPequeno2: false });
                this.muestraTooltip(true, 'error', validacion, error.message.mensaje);
            }, 3000);
            var type = ($this.state.ramo === "V") ? "EVENT_REGISTRO_SIG-VIDA-INCORRECTOS" : "EVENT_REGISTRO_SIG-GMM-INCORRECTOS";
            $this.props.tagManager({ "type": type, "dispositivo": $this.props.dispositivo });
        });
    }

    muestraTooltip = (show, type?, titulo?, mensaje?) => {
        const btnAyuda = localStorage.getItem("btnAyuda");

        if(show) {
            if(type === "error" || type === undefined) {
                contador = contador +1;
    
                if(contador <= 2) {
                    setTimeout(() => {
                        this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
                    }, 300);
                }
                else {
                    if(btnAyuda !== undefined && btnAyuda === "true"){
                        this.setState({ showModalAyuda: true, tipoModalAyuda: "error"});
                    } else {
                        setTimeout(() => {
                            this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
                        }, 300);
                    }
                }
            } else {
                setTimeout(() => {
                    this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
                }, 300);
            }
        }
    }

    cierraTooltip = e => {
        this.setState({
            showTooltip: !this.state.showTooltip
        });
    }

    cierraTooltip2 = e => {
        this.setState({
            showModalAyuda: !this.state.showModalAyuda 
        });
    }

    handlerAvisosAceptados = (value) => {
        console.log("Avisos aceptados " + value);
        this.setState({
            avisosAceptados: value
        });
    }

    cancelar = () => {
        console.log("cancelar");
        this.muestraTooltip(false);
        this.props.tagManager({ "type": "EVENT_REGISTRO_POLIZA-CANCELAR", "dispositivo": this.props.dispositivo });
        localStorage.removeItem("aceptarAviso");
        localStorage.removeItem("mediosElectronicos");
    }

    regresar = () => {
        console.log("regresar");
        this.props.tagManager({ "type": "REGISTRO_POLIZA_REGRESAR_POLIZA", "dispositivo": this.props.dispositivo });
        this.props.avisoPrivacidad(true);
        this.setState({ "avisoAceptado": false });
        this.props.change("avisoAceptado", false);
        this.setState({ "habilitaBtnAviso": true });
        this.props.avisoTerminos(true);
        this.setState({ "mediosElectronicos": false });
        this.props.change("mediosElectronicos", false);
        goTo("login");
    }

    envioAutomatico = () => {
        this.props.handleSubmit(values => this.props.onSubmit({ ...values }))();
    }

    handleBlurPolizaBNMX = () => {
        if (document.getElementsByName('placas')[0] === undefined || document.getElementsByName('motor')[0] === undefined ||
            !document.getElementsByName("tipo") || document.getElementsByName('rfcbnmx') === undefined ||
            document.getElementsByName("fechaNacimiento") === undefined) {
            console.log("");
        } else if ((document.getElementsByName('placas')[0].value !== "" || document.getElementsByName('motor')[0].value !== "") &&
            document.getElementsByName("tipo") && document.getElementsByName('rfcbnmx')[0].value !== "" &&
            document.getElementsByName("fechaNacimiento")[0].value !== "") {
            this.handleBlurPolizaBNMX2();
        }
    }

    validarCamposPolizaBNMX = () => {
        let placas = "";
        let motor = "";
        const rfc = document.getElementsByName('rfcbnmx')[0].value;
        const fechaNacimiento = document.getElementsByName('fechaNacimiento')[0].value;
        localStorage.setItem('fechaNacimientoBMX', fechaNacimiento);

        if (this.state.placas === true) {
            placas = document.getElementsByName('placas')[0].value;
        } else {
            motor = document.getElementsByName('motor')[0].value;
        }

        if (rfc === "" || fechaNacimiento === "" && (motor === "" || placas === "")) {
            this.props.handleSubmit(values => this.props.onSubmit({ ...values }))();
        } else {
            this.validacionesPolizaBNMX();
        }
    }

    validacionesPolizaBNMX = () => {
        const oForm = this.props.dataForm;
        if (this.props.poliza_valida === false && this.props.grupo &&
            this.props.motor && (oForm.motor !== "" || oForm.placas !== "")) {
            oForm.poliza = this.state.polizaReal;
            console.log("poliza real", this.state.polizaReal);
            if (this.props.referencia) {
                oForm.poliza = this.props.referencia;
            }
            console.log('aqui se pierde?', oForm);
            if (this.state.polizaBanamex) {
                this.getFechaNacimiento();
                this.setRFC(oForm.rfcbnmx);
                this.actualizaPolizaBanamex(oForm);
            } else {
                this.validarAuto(oForm);
            }
        }
        else if (this.props.poliza_valida === false && this.props.grupo && this.props.motor && this.state.polizaBanamex) {
            this.getFechaNacimiento();
            this.setRFC(oForm.rfcbnmx);
            this.actualizaPolizaBanamex(oForm);
        }
    }

    handleBlurPolizaBNMX2 = () => {
        const oForm = this.props.dataForm;
        if (oForm.poliza.startsWith('CBX') || oForm.poliza.startsWith('cbx')) {
            if (oForm.poliza.length > 10) {
                oForm.poliza = oForm.poliza.slice(0, 4) + oForm.poliza.slice(5);
                console.log("Poliza corregida:" + oForm.poliza);
            }
        }

        if (this.props.poliza_valida === false && this.props.grupo && this.props.motor && (oForm.motor !== "" || oForm.placas !== "")) {
            oForm.poliza = this.state.polizaReal;
            console.log("poliza real", this.state.polizaReal);
            if (this.props.referencia) {
                oForm.poliza = this.props.referencia;
                console.log("referencia", this.props.referencia);
            }

            if (this.state.polizaBanamex) {
                this.getFechaNacimiento();
                this.setRFC(oForm.rfcbnmx);
                this.actualizaPolizaBanamex(oForm);
            } else {
                this.validarAuto(oForm);
            }
        }
        else if (this.props.poliza_valida === false && this.props.grupo && this.props.motor && this.state.polizaBanamex) {
            this.getFechaNacimiento();
            this.setRFC(oForm.rfcbnmx);
            this.actualizaPolizaBanamex(oForm);
        }
    }

    vaildarRegistroInconcluso = (oForm, oResult) => {
        console.log('aqui', this.state.loadingPequeno);
        this.setState({ loadingPequeno: true });
        console.log('aqui', this.state.loadingPequeno);
        let certificadoCerosRegInc = "";
        let polizaCeros = "";

        if (oResult.sistema === "INFO") {
            polizaCeros = oForm.poliza.padStart(14, 0);
        } else if (oResult.sistema === "AZUL") {
            polizaCeros = oForm.poliza.padStart(10, 0);
        }

        if (oForm.certificado === "") {
            localStorage.setItem("certificado", certificadoCerosRegInc);
        } else {
            console.log(oForm.certificado);
            certificadoCerosRegInc = oForm.certificado !== undefined ? oForm.certificado.padStart(8, 0) : oForm.certificado;
            localStorage.setItem("certificado", certificadoCerosRegInc);
        }
        console.log('esta es la respuesta inconclusa', oResult);
        new callService({
            service: "registro.incConsultaRegistroPoliza",
            secure: true,
            data: {
                poliza: polizaCeros,
                certificado: certificadoCerosRegInc,
                sistema: oResult.sistema,
            }
        }).execute().then((respuesta) => {
            console.log('esta es la respuesta inconclusa', respuesta);
            if (respuesta.banConcluirReg.toString() === 'false') {
                this.validaUsuario(respuesta, oResult, polizaCeros);
            } else {
                localStorage.removeItem("banConcluirReg");
            }
        })
        this.vaildarRegistroInconcluso2(oForm, oResult);
    }

    vaildarRegistroInconcluso2 = (oForm, oResult) => {
        setTimeout(() => {
            if (oResult.certificado) {
                this.setState({ loadingPequeno: false });
                this.props.guardarConfiguracion(oResult);
            } else {
                if (oForm.poliza.startsWith('CBX') || oForm.poliza.startsWith('cbx')) {
                    this.props.guardarConfiguracion(oResult);
                    this.setState({ loadingPequeno: false });
                    this.setState({ polizaBanamex: true });
                    this.props.change("polizaBanamex", true);
                    this.setPolizaReal(oResult.numPoliza);
                    this.checkPolizaBanamex(oForm.poliza);
                    polizaBNMX = true;
                } else if (oResult.grupo && oResult.motor) {
                    this.setState({ loadingPequeno: false });
                } else {
                    console.log('poliza sin nada');
                    this.setState({ polizaBanamex: false });
                    this.props.change("polizaBanamex", false);
                    localStorage.setItem('polizaNueva', this.props.initialValues.poliza);
                    localStorage.setItem('inicioVigenciaPolizaNueva', this.props.initialValues.inicioVigenciaPoliza);
                    console.log(oForm);
                    this.setState({ loadingPequeno: false });
                    this.pasoSiguiente();
                }
            }
        }, 7000);
    }

    pasarBtn = () => {
        setTimeout(() => {
            document.getElementById("btnAceptarAviso").focus();
        }, 10);
        this.pasoSiguiente();
    }

    handlePressSieguiente = () => {
        const inputs = document.getElementsByTagName('input');
        setTimeout(() => {
            for (const i of inputs) {
                if (this.state.polizaBanamex) {
                    if ("rfcbnmx" === i.name) {
                        document.getElementById(i.id).focus();
                    }
                } else if (this.props.grupo && this.props.certificado) {
                    if ("certificado" === i.name) {
                        document.getElementById(i.id).focus();
                    }
                } else {
                    this.handlePressSieguiente2();
                }
            }
        }, 1000);
    }

    handlePressSieguiente2 = () => {
        if (this.props.grupo && this.props.motor) {
            if ("placas" === i.name) {
                document.getElementById(i.id).focus()
            }
        }
        else {
            this.pasarBtn();
        }
    }

    siguiente = () => {
        console.log('aqui entra la segunda vez');
        const oForm = this.props.dataForm;
        console.log("Formulario", oForm);
        const fecha = document.getElementsByName("fechaPoliza")[0].value;
        const btnAyuda = localStorage.getItem("btnAyuda");
        this.setState({errorAvisosAceptados: !this.state.avisosAceptados});

        if(!oForm.poliza || fecha === ""){
            console.log("entra a validar campos vacios");
            contador = contador+1;
            if(contador <= 2) {
                this.props.handleSubmit(values => this.props.onSubmit({ ...values }))();
            }else {
                if(btnAyuda !== undefined && btnAyuda === "true"){
                    this.setState({ showModalAyuda: true, tipoModalAyuda: "error"});
                }else {
                    this.props.handleSubmit(values => this.props.onSubmit({ ...values }))();
                }
            }
        }else{
            if(this.state.avisosAceptados) {
                this.siguiente2(oForm);
            } else {
                console.log("Avisos no aceptados.");
            }
        }
    }

    siguiente2 = (oForm) => {
        if (polizaBNMX === false && certificadoPoliza === false && polizaAutos === false) {
            this.validarPolizaClick();
            console.log('Aqui es la primer validacion de poliza');
        } else if (polizaBNMX === true && certificadoPoliza === false && polizaAutos === false) {
            console.log('aqui entra por ser banamex');
            this.validarCamposPolizaBNMX();
        } else if (polizaBNMX === false && certificadoPoliza !== false && polizaAutos === false) {
            console.log('aqui entra por ser certificado');
            this.validarCertificado(oForm);
        } else if (polizaBNMX === false && certificadoPoliza === false && polizaAutos === true) {
            console.log('aqui entra por ser poliza autos');
            this.validarMotorPlacas();
        } else {
            console.log('else');
            this.props.handleSubmit(values => this.props.onSubmit({ ...values }))();
        }
    }

    pasoSiguiente = () => {
        this.setState({ fechaIncompleta: false });
        localStorage.setItem('sistema', this.state.sistema);
        this.props.tagManager({
            "type": "EVENT_REGISTRO_SIG-CORRECTOS-POLIZA", "dispositivo": this.props.dispositivo, "ramo": localStorage.getItem("ramo")
        });
        this.envioAutomatico();
    }

    whatIWantToRunOnSubmit = (values) => {
        if (this.props.poliza_valida === true) {
            this.props.onSubmit({ ...values });
        }
    }

    aceptarAvisoPrivacidad = () => {
        this.props.tagManager({ "type": "ACEPTO_AVISO_PRIVACIDAD", "dispositivo": this.props.dispositivo });
        this.setState({ "avisoAceptado": true });
        this.props.change("avisoAceptado", true);
        this.props.avisoPrivacidad(false);
    }

    checkAviso = () => {
        console.log("Estado del checkbox Aviso: " + aceptarAviso.checked);
        this.habilitaBotonPrivacidad();
    }

    aceptarTerminosCondiciones = () => {
        this.props.tagManager({ "type": "ACEPTO_MEDIOS_ELECTRONICOS", "dispositivo": this.props.dispositivo });
        this.setState({ "mediosElectronicos": true });
        this.props.change("mediosElectronicos", true);
        this.props.avisoPrivacidad(false);
    }

    checkAvisoTerminos = () => {
        console.log("Estado del checkbox Medios: " + mediosElectronicos.checked);
        this.habilitaBotonPrivacidad();
    }

    habilitaBotonPrivacidad = () => {
        if (aceptarAviso.checked === false || mediosElectronicos.checked === false) {
            this.setState({ "habilitaBtnAviso": true });
        } else {
            this.setState({ "habilitaBtnAviso": false });
        }
    }

    aceptarAvisoMedios = () => {
        this.aceptarAvisoPrivacidad();
        this.aceptarTerminosCondiciones();
        window.scrollTo(0, 0);
    }

    cancelarAvisoPrivacidad = () => {
        console.log("No se acepto regresar a home.")
    }

    checkContratante = () => {
        this.props.change("esContratante", true);
        this.props.change("tipo", "contratante");
        isContrat = true;
    }

    checkConductor = () => {
        this.props.change("esContratante", false);
        this.props.change("tipo", "conductor");
        isContrat = false;
    }

    showModal2 = () => {
        $("#modal-terminos-condiciones").modal({ backdrop: "static", keyboard: false });
    }

    onFocusFecha = (event) => {
        var dia = "";
        var mes = "";
        var anio = "";
        this.setState({ inputType: 'date' });
        $(modal1).modal("hide");

        dia = event.currentTarget.value.substr(8, 9);
        mes = event.currentTarget.value.substr(5, 2);
        anio = event.currentTarget.value.substr(0, 4);
        document.getElementsByName("fechaPoliza")[0].value = dia + "/" + mes + "/" + anio;
    }

    onFocusFechaNacimiento = (event) => {
        var dia = "";
        var mes = "";
        var anio = "";
        this.setState({ inputType2: 'date' });

        dia = event.currentTarget.value.substr(8, 9);
        mes = event.currentTarget.value.substr(5, 2);
        anio = event.currentTarget.value.substr(0, 4);
        document.getElementsByName("fechaNacimiento")[0].value = dia + "/" + mes + "/" + anio;
    }

    onBlurFecha = () => {
        console.log('oblur fecha')
        this.setState({ inputType: 'text' });
        if (document.getElementsByName("fechaPoliza")[0].value.includes("-")) {
            this.setState({ inputType: 'date' });
        }
    }

    onBlurFechaNacimiento = () => {
        this.setState({ inputType2: 'text' });

        if (document.getElementsByName("fechaNacimiento")[0] &&
            document.getElementsByName("fechaNacimiento")[0].value.includes("-")) {
            this.setState({ inputType2: 'date' });
        }
    }

    validacionAnio = () => {
        const fecha = document.getElementsByName("fechaPoliza")[0].value;
        const transformada = fecha.split("-");
        if (transformada[0] > "9999") {
            fecha.value = "";
        }
    }

    validarCambio = () => {
        this.resetConfiguracion();
        banderaIdenPoliza = false;
        certificadoPoliza = false;
        polizaBNMX = false;
    }

    validacionAnio2 = () => {
        const fecha = document.getElementsByName("fechaNacimiento")[0].value;
        const transformada = fecha.split("-");
        if (transformada[0] > "9999") {
            fecha.value = "";
        }
    }

    expandir = () => {
        var mostrar = document.getElementById("steppervertical");
        if (mostrar.style.display === "block") {
            mostrar.style.display = "none";
        } else {
            mostrar.style.display = "block";
        }
    }

    checkPlacas = () => {
        this.setState({ "placas": true });
        this.setState({ "serie": false });
        var motor = document.getElementsByName("motor");

        if (motor !== undefined) {
            this.props.change("motor", "");
        }
    }

    checkNumeroSerie = () => {
        this.setState({ "placas": false });
        this.setState({ "serie": true });
        var placas = document.getElementsByName("placas");

        if (placas !== undefined) {
            this.props.change("placas", "");
        }
    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <form onSubmit={handleSubmit(this.whatIWantToRunOnSubmit)} className="remove-all-styles">

                <MensajeAyuda onClose={this.cierraTooltip2} show={this.state.showModalAyuda} typeModal={this.state.tipoModalAyuda}></MensajeAyuda>

                <ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
                    show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
                </ModalSintillo>
            
                {
                    <div>

                        <div className="flex layout-gt-md-row layout-md-row layout-xs-column layout-sm-column layout-align-center-center">
                            <StepperPaso1></StepperPaso1>
                            <div id="stepperesponsivo">
                                <span id="registropaso1"></span>
                                <label id="registroletra1">PÓLIZA</label>
                                <span id="expancion" onClick={this.expandir}></span>
                                <div style={{ maxWidth: 380, maxHeight: 400, margin: 'auto' }} id="steppervertical">
                                    <StepperResposnsivo1></StepperResposnsivo1>
                                </div>
                            </div>
                        </div>

                        <div id="div-gral-return">
                            <div className="div-return">
                                <div className="titulo1">
                                    <label className="txt-1">Ingresa la información solicitada</label>
                                </div>
                            </div>
                        </div>

                        <div className="datos-wrap mt-10" id="datos-wrap" style={{ marginTop: "35px" }}>
                            <div className="row">
                                <div className="col-md-6 col-sm-6 col-xs-12" >
                                    <div id="poliza-registro">
                                        <Field
                                            name="poliza" type="text" component={campo}
                                            onBlur={this.handleBlur}
                                            normalize={espacios} max="15" label="No. Póliza o Referencia"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 col-sm-6 col-xs-12">
                                    <div id="fecha-vigencia">
                                        <Field
                                            name="fechaPoliza" type={this.state.inputType}
                                            id="fechaPoliza" max="10" component={campo}
                                            label="Fecha de inicio de vigencia"
                                            onBlur={this.handleBlur}
                                            focus={this.onFocusFecha}
                                            onChange={this.validacionAnio}
                                        />
                                        <span id="calendario-registroFecha" className="material-icons outlined" onClick={this.onFocusFecha.bind(this)}>calendar_today</span>
                                        {this.state.loadingPequeno ? <div className="spinner" id="spinner-validacion-poliza"></div> : null}
                                    </div>
                                </div>
                                {this.state.rfcisEmpty === true ?
                                    <div className="col-md-6 col-sm-6 col-xs-12">
                                        <div id="rfc2-registro" style={{ width: "75%" }}>
                                            <Field
                                                name="rfcValidar" type="text" component={campo}
                                                onBlur={this.handleBlur}
                                                normalize={espacios} max="15" label="RFC"
                                            />
                                        </div>
                                    </div>
                                    : <div></div>}
                            </div>

                            {(this.state.polizaBanamex || this.state.fechaIncompleta) &&
                                <div className="datos-wrap">
                                    <div className="row">
                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <div id="rfc-registro">
                                                <Field
                                                    name="rfcbnmx" type="text" component={campo} label="RFC"
                                                    onBlur={this.handleBlur} max="15"
                                                    normalize={espacios} style={{ textTransform: "uppercase" }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <div id="fechaNacimiento-registro">
                                                <Field
                                                    name="fechaNacimiento" type={this.state.inputType2}
                                                    component={campo} label="Fecha de nacimiento"
                                                    onBlur={this.handleBlur} max="10"
                                                    onChange={this.validacionAnio2}
                                                    focus={this.onFocusFechaNacimiento}
                                                />
                                                <span id="calendario-registroFecha"
                                                    className="material-icons outlined"
                                                    onClick={this.onFocusFechaNacimiento.bind(this)}>calendar_today</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }

                            {this.state.polizaBanamex &&
                                <div className="datos-wrap">
                                    <div className="row">
                                        <div className="col-sm-12 text-center" style={{ marginTop: "20px" }}>

                                            <div className="col-sm-6 col-xs-6 text-center" id="btnCheck">
                                                <div className="checkbox-blue">
                                                    <div className="blu-input-radio">
                                                        <Field
                                                            name="tipo" component="input" type="radio" value="contratante" id="tipo"
                                                            onClick={this.checkContratante}
                                                            style={{ marginTop: "-9px", opacity: "100%", marginLeft: "40px", height: "1.3em" }}
                                                        />
                                                    </div>
                                                    <div style={{ marginTop: "0px", color: "#33486C", fontSize: "14px" }}>
                                                        Soy Contratante
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-sm-6 col-xs-6 text-center" id="btnCheck" style={{ marginLeft: "-110px" }}>
                                                <div className="checkbox-blue">
                                                    <div className="blu-input-radio">
                                                        <Field
                                                            name="tipo" component="input" type="radio" value="conductor" id="tipo"
                                                            onClick={this.checkConductor.bind(this)}
                                                            style={{ marginTop: "-9px", opacity: "100%", marginLeft: "20px", marginRight: "15px", height: "1.3em" }}
                                                        />
                                                    </div>
                                                    <div style={{ marginTop: "0px", color: "#33486C", fontSize: "14px" }}>
                                                        Soy Conductor
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            }

                            {this.props.grupo && this.props.certificado &&
                                <div className="row">
                                    <div className="col-md-6 col-sm-6 col-xs-12">
                                        <div id="certificado-registro">
                                            <Field
                                                name="certificado" type="text" component={campo}
                                                onBlur={this.handleBlur} normalize={espacios} max="10"
                                                label={(this.state.ramo === "V" && this.props.certificado === "INFO") ? "Código cliente" : "No. de certificado"}
                                            />
                                            {this.state.loadingPequeno2 ? <div className="spinner" id="spinner-validacion-certificado"></div> : null}
                                        </div>
                                    </div>
                                </div>
                            }

                            {this.props.grupo && this.props.motor &&
                                <div className="datos-wrap">
                                    <div className="row">
                                        <label id="label-pregunta1">¿Con qué información deseas registrar tu auto?</label>
                                        <div className="col-sm-12 text-center" style={{ marginTop: "20px" }}>

                                            <div className="col-sm-6 col-xs-6 text-center" id="btnCheck">
                                                <div className="checkbox-blue">
                                                    <div className="blu-input-radio">
                                                        <Field
                                                            name="tipoAuto" component="input" type="radio" value="placas" id="tipoAuto"
                                                            onClick={this.checkPlacas}
                                                            style={{ marginTop: "-9px", opacity: "100%", marginLeft: "40px", height: "1.3em" }}
                                                        />
                                                    </div>
                                                    <div style={{ marginTop: "0px", color: "#33486C", fontSize: "14px" }}>
                                                        Placas
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-sm-6 col-xs-6 text-center" id="btnCheck" style={{ marginLeft: "-110px" }}>
                                                <div className="checkbox-blue">
                                                    <div className="blu-input-radio">
                                                        <Field
                                                            name="tipoAuto" component="input" type="radio" value="numeroSerie" id="tipoAuto"
                                                            onClick={this.checkNumeroSerie.bind(this)}
                                                            style={{ marginTop: "-9px", opacity: "100%", marginLeft: "20px", marginRight: "15px", height: "1.3em" }}
                                                        />
                                                    </div>
                                                    <div style={{ marginTop: "0px", color: "#33486C", fontSize: "14px" }}>
                                                        Número de serie
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            }

                            <div className="row">
                                {this.state.placas === true && <div className="col-md-6 col-sm-6 col-xs-12">
                                    <div style={{ width: "70%" }} id="estiPlaca">
                                        <Field
                                            name="placas" type="text" component={campo} id="placas"
                                            focus={this.handleFocus.bind(this)}
                                            normalize={espacios} max="12" label="Placa"
                                        />
                                    </div>
                                </div>}

                                {this.state.serie === true && <div className="col-md-6 col-sm-6 col-xs-12">
                                    <div id="estiNumSerie">
                                        <Field
                                            name="motor" type="text" id="motor"
                                            component={campo} focus={this.handleFocus.bind(this)}
                                            normalize={espacios} max="22" label="Número de serie"
                                        />
                                        {this.state.loadingPequenoMotor ? <div className="spinner" id="spinner-validacion-certificado"></div> : null}
                                    </div>
                                </div>}
                            </div>

                            <Field name="polizaReal" component="input" type="hidden" />
                            <Field name="ramo" component="input" type="hidden" />
                            <Field name="inicioVigenciaPoliza" component="input" type="hidden" />
                            <Field name="inicioVigenciaPolizaDate" component="input" type="hidden" />

                            <div className="row">
                                <AvisoPrivacidad handler={this.handlerAvisosAceptados} showError={this.state.errorAvisosAceptados}></AvisoPrivacidad>
                            </div>

                            {this.props.conectaMovil === false &&
                                <div className="row">
                                    <div className="col-md-6 col-sm-6 col-xs-12" style={{ marginTop: '-10px' }}>
                                        <button type="button" onClick={this.siguiente}

                                            id="btnAceptarAviso" className="orange-rectangle btn">Continuar</button>
                                    </div>
                                </div>}

                            {this.props.conectaMovil === true &&
                                <div className="row btn-bottom">
                                    <div className="col-xs-12">
                                        <button type="button" onClick={this.siguiente}
                                            style={{ marginTop: '2px' }}
                                            id="btnAceptarAviso" className="orange-rectangle btn">Continuar</button>
                                    </div>
                                </div>}
                        </div>
                    </div>
                }
            </form>
        );
    }
}

PolizaForm = reduxForm({ form: "datos-poliza", validate, onSubmitFail })(PolizaForm);
export default connect(mapState, mapDispatch)(PolizaForm);



// WEBPACK FOOTER //
// ./src/gnp-registro/poliza.frm.js